/**
 * NexusMayhem — Game initialization
 *
 * This is the "setup function" that configures the Engine
 * for the Nexus Mayhem bullet heaven game. Registers all
 * systems, spawns the player, loads content.
 */

import { MovementSystem } from '../engine/systems/MovementSystem';
import { CollisionSystem } from '../engine/systems/CollisionSystem';
import { SpawnSystem } from '../engine/systems/SpawnSystem';
import { WeaponSystem } from '../engine/systems/WeaponSystem';
import { PickupSystem } from '../engine/systems/PickupSystem';
import { RenderSystem } from '../engine/systems/RenderSystem';
import { ContentLoader } from '../engine/ContentLoader';

import enemyData from '../content/enemies.json';
import weaponData from '../content/weapons.json';
import upgradeData from '../content/upgrades.json';

export function initNexusMayhem(engine) {
  // Load content
  const content = new ContentLoader();
  content.loadEnemies(enemyData);
  content.loadWeapons(weaponData);
  content.loadUpgrades(upgradeData);
  engine.content = content;

  // Set default weapon stats (spread shot)
  const defaultWeapon = content.getWeapon('spread');
  if (defaultWeapon) {
    engine.playerStats.fireRate = defaultWeapon.fireRate;
    engine.playerStats.damage = defaultWeapon.damage;
    engine.playerStats.projectileCount = defaultWeapon.projectiles;
    engine.playerStats.projectileSpread = defaultWeapon.spread;
    engine.playerStats.projectileSpeed = defaultWeapon.speed;
  }

  // Register systems (order matters!)
  engine.addSystem(new MovementSystem());
  engine.addSystem(new WeaponSystem());
  engine.addSystem(new PickupSystem());
  engine.addSystem(new SpawnSystem(content));
  engine.addSystem(new CollisionSystem());

  // Render system is special — runs in draw phase
  engine.setRenderSystem(new RenderSystem());

  // Spawn player at center
  spawnPlayer(engine);

  return engine;
}

function spawnPlayer(engine) {
  const id = engine.entities.create();

  engine.entities.addComponent(id, 'position', {
    x: engine.width / 2,
    y: engine.height / 2,
    angle: 0,
  });

  engine.entities.addComponent(id, 'velocity', { vx: 0, vy: 0 });

  engine.entities.addComponent(id, 'render', {
    shape: 'triangle',
    size: 14,
    color: '#00ff41',
    glow: true,
  });

  engine.entities.addComponent(id, 'health', {
    current: 100,
    max: 100,
  });

  engine.entities.addTag(id, 'player');

  return id;
}
